// Base URL
export const BASE_URL = process.env.REACT_APP_BASE_URL+"/api/v2";

// Institute Admin Dashboard
const INSTITUTE = '/institute'
const ADMIN = `${INSTITUTE}/admin`;
const DASHBOARD = `${ADMIN}/dashboard`;
export const STUDENT_ACTIVITIES = `${DASHBOARD}/student_activities`;
export const NOT_LOGGED_IN_COUNT = `${STUDENT_ACTIVITIES}/not_logged_in_count`;
export const ACTIVE_COUNT = `${STUDENT_ACTIVITIES}/active_count`;
export const SIGNUPS_COUNT = `${STUDENT_ACTIVITIES}/signups_count`;
export const LOGINS_COUNT = `${STUDENT_ACTIVITIES}/logins_count`;
export const NO_OF_LOGINS = `${STUDENT_ACTIVITIES}/no_of_logins`;
export const NOT_LOGGED_IN = `${STUDENT_ACTIVITIES}/not_logged_in`;
export const SIGNUPS = `${STUDENT_ACTIVITIES}/signups`;
export const ACTIVE_STUDENTS = `${STUDENT_ACTIVITIES}/active`;
export const PDF_VIEWED = `${STUDENT_ACTIVITIES}/pdf_viewed`
export const VIDEO_VIEWED = `${STUDENT_ACTIVITIES}/video_viewed`
export const QUICK_QUIZ_COUNT = `${STUDENT_ACTIVITIES}/quickquiz_count`
export const EXERCISE_COUNT = `${STUDENT_ACTIVITIES}/exercise_count`
export const CLASS_LOGINS = `${STUDENT_ACTIVITIES}/class_logins`
export const BRANCH_LOGINS = `${STUDENT_ACTIVITIES}/branch_logins`

// Reports

export const DOWNLOAD_INSTITUTE_ACTIVITY_REPORT = `${STUDENT_ACTIVITIES}/download_report.xls`


// Institue + Private students dashboard
const ALL_STUDENTS_DASHBOARD = '/all/admin/dashboard';
export const ALL_STUDENT_ACTIVITIES = `${ALL_STUDENTS_DASHBOARD}/student_activities`;
export const TOTAL_ALL_STUDENTS_COUNT = `${ALL_STUDENT_ACTIVITIES}/total_count`
export const TOTAL_STUDENT_LOGINS_COUNT = `${ALL_STUDENT_ACTIVITIES}/logins_count`;
